//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	props:{
        info: {
            default: res=>{
                return {
                    title: '标题',
                    disabled: false,
                    type: 'large',
                    callback: null,
                    style: '',
                    show: false,
                    mainStyle: '',
                }
            },
            type: Object
        },
	},
	mounted(){

	}
}



// WEBPACK FOOTER //
// ./src/components/ui/dialogbox.vue